import React, { Component } from "react";
import classnames from "classnames";
import axios from "axios";

class SessionMenu extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		currentUserData: JSON.parse(localStorage.getItem('userData')),
		switchTabsStatus: 0,
		showLiveTab: 1,
		showOndemandTab: 1,
		showAllTabs: true,
    }
	
}
 
componentDidMount(){
	this.updateForTabsSwitch();
}

checkForSwitchTabs=()=>{
	let userInfo = JSON.parse(localStorage.getItem('userData'));
	if ( userInfo.channelSettings )
		{
			this.setState({
				switchTabsStatus: userInfo.channelSettings.firstTabOnDemand,
				showLiveTab: userInfo.channelSettings.showLiveTab,
				showOndemandTab: userInfo.channelSettings.showOndemandTab,
			}, ()=>{
				
				if ( this.state.showLiveTab != 1 && this.props.chosenClassesMenu === 'Live' )
					{
						this.props.updateStateFromChild({chosenClassesMenu: 'My schedule'})
					}
					
				if ( this.state.showOndemandTab != 1 && this.props.chosenClassesMenu === 'On-demand' )
					{
						this.props.updateStateFromChild({chosenClassesMenu: 'My schedule'})
					}
				
				
				if ( this.state.showLiveTab != 1 && this.state.showOndemandTab != 1 )
					{
						this.setState({
							showAllTabs: false,
						});
					}
				else 
					{
						this.setState({
							showAllTabs: true,
						});
					}					
				
			});
		}
}

updateForTabsSwitch=()=>{
	console.log('updateForTabsSwitch');
	let userInfo = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};
	
	let token = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).token : '';
    axios.defaults.headers.common['Authorization'] = token;	
	axios.post(process.env.REACT_APP_API_URL +'/api/v1/session/getUserChannelInfo').then(res => {
		let newData = res.data.responseData;
		userInfo.channelSettings = newData;
		localStorage.setItem('userData', JSON.stringify(userInfo));
		this.checkForSwitchTabs();
	}).catch(err =>{});
	
}

  render() {
	 return (
		<div className={classnames({'sessions_menu': true, 'pop_session_menu': this.props.parentComponent == 'bookmarkClasses'})}>
			{ this.state.currentUserData && this.state.currentUserData.showLiveAndOnDemand && this.state.showAllTabs ?
				<div>
					{ this.state.switchTabsStatus == 0 ?
						<div className={classnames({'inlineHolder': true, 'holdLiveAndOd': true, 'halfWidth': (this.state.showLiveTab != 1 || this.state.showOndemandTab != 1)})} >
							{this.state.showLiveTab == 1 &&
								<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'Live', 'widder_sess_menu': this.props.parentComponent == 'bookmarkClasses'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'Live'})}>
									<div className="session_menu_icon live_icon"></div>
									<div className="session_menu_title">Live</div>
								</div>
							}
							{this.state.showOndemandTab == 1 &&
								<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'On-demand', 'widder_sess_menu': this.props.parentComponent == 'bookmarkClasses'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'On-demand'})}>
									<div className="session_menu_icon ondemand_icon"></div>
									<div className="session_menu_title">On-demand</div>
								</div>
							}
						</div>
						:
						<div className={classnames({'inlineHolder': true, 'holdLiveAndOd': true, 'halfWidth': (this.state.showLiveTab != 1 || this.state.showOndemandTab != 1)})} >
							{this.state.showOndemandTab == 1 &&
								<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'On-demand', 'widder_sess_menu': this.props.parentComponent == 'bookmarkClasses'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'On-demand'})}>
									<div className="session_menu_icon ondemand_icon"></div>
									<div className="session_menu_title">On-demand</div>
								</div>
							}
							{this.state.showLiveTab == 1 &&
								<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'Live', 'widder_sess_menu': this.props.parentComponent == 'bookmarkClasses'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'Live'})}>
									<div className="session_menu_icon live_icon"></div>
									<div className="session_menu_title">Live</div>
								</div>
							}
						</div>
					}
					
					<div className={classnames({'inlineHolder': true, 'myScheduleHold': true, 'halfWidth': (this.state.showLiveTab != 1 || this.state.showOndemandTab != 1)})} >
						{ this.props.parentComponent == 'mainPage' &&
							<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'Programs'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'Programs'})}>
								<div className="session_menu_icon programs_icon"></div>
								<div className="session_menu_title">Programs</div>
							</div>
						}
					</div>
					
					<div className={classnames({'inlineHolder': true, 'myScheduleHold': true, 'halfWidth': (this.state.showLiveTab != 1 || this.state.showOndemandTab != 1)})} >
						{ this.props.parentComponent == 'mainPage' &&
							<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'My schedule'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'My schedule'})}>
								<div className="session_menu_icon schedule_icon"></div>
								<div className="session_menu_title">My schedule</div>
							</div>
						}
					</div>
					<div className={classnames({'inlineHolder': true, 'myScheduleHold': true, 'halfWidth': (this.state.showLiveTab != 1 || this.state.showOndemandTab != 1)})} >
						{ this.props.parentComponent == 'mainPage' &&
							<div className={classnames({'session_menu_option': true, 'active': this.props.chosenClassesMenu === 'Challenges'})} onClick={() => this.props.updateStateFromChild({chosenClassesMenu: 'Challenges'})}>
								<div className="session_menu_icon challenges_icon"></div>
								<div className="session_menu_title">Challenges</div>
							</div>
						}
					</div>
				</div>
				:
				''
			}
		</div>
    );
  }
}
export default SessionMenu;
